export default {
  title: {
    en: 'Gift subscription',
  },
  text: {
    en: `
    {giverName} sent you a {monthsCount, plural, one {month} other {# months}} gift subscription to 
    your <b>{recipientEmail}</b> account. Would you like to redeem your gift subscription to this 
    account or another account?
  `,
  },
  confirmTitle: {
    en: 'Yes',
  },
  cancelTitle: {
    en: 'Another account',
  },
}
